import { Breadcrumbs, Stack } from '@mui/material'
import { NavigateNext } from '@mui/icons-material'
import { ReactComponent as FolderSvg } from '../folder.svg'
import { ReactComponent as FolderOutline } from '../meta-folder-outline.svg'
import { Subtitle, Title } from './styles'

function Header({ search, ads, campaigns, reportData }) {
  const renderHeader = () => {
    if (search === 'campaign') {
      if (campaigns.length === 0) {
        return (
          <>
            <FolderSvg fill="currentColor" />
            <Title variant="h5">
              Todas campanhas <Subtitle>(no período)</Subtitle>
            </Title>
          </>
        )
      }
      if (campaigns.length === 1) {
        const selectedCampaign = (reportData && reportData.find((c) => c.CampaignId === campaigns[0])) || null

        if (selectedCampaign) {
          return (
            <>
              <FolderSvg fill="currentColor" />
              <Title variant="h5">
                Campanha: <Subtitle>{selectedCampaign.CampaignName}</Subtitle>
              </Title>
            </>
          )
        }
        return null
      }

      return (
        <>
          <FolderSvg fill="currentColor" />
          <Title variant="h5">
            Campanhas: <Subtitle>{campaigns.length} selecionadas</Subtitle>
          </Title>
        </>
      )
    }

    if (campaigns.length === 0) {
      return (
        <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
          <Title variant="h5">
            <FolderOutline fill="currentColor" />
            <Subtitle>Campanha:</Subtitle> Todas
          </Title>
          <Title>
            Anúncios <Subtitle>(no período)</Subtitle>{' '}
          </Title>
        </Breadcrumbs>
      )
    }
    if (campaigns.length === 1) {
      const selectedCampaign = (reportData && reportData.find((c) => c.CampaignId === campaigns[0])) || null

      if (selectedCampaign) {
        return (
          <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
            <Title variant="h5">
              <FolderOutline fill="currentColor" />
              <Subtitle>Campanha:</Subtitle> {selectedCampaign.CampaignName}
            </Title>
            <Title>
              Anúncios <Subtitle>(no período)</Subtitle>{' '}
            </Title>
          </Breadcrumbs>
        )
      }
      return null
    }

    return (
      <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
        <Title variant="h5">
          <FolderOutline fill="currentColor" />
          <Subtitle>Campanhas:</Subtitle> {campaigns.length} selecionadas
        </Title>
        <Title>
          Anúncios <Subtitle>(no período)</Subtitle>{' '}
        </Title>
      </Breadcrumbs>
    )
  }

  return (
    <Stack
      gap="0.5rem"
      flexDirection="row"
      alignItems="center"
      sx={{ color: '#666' }}
      data-testid="stack-header-testid"
    >
      {renderHeader()}
    </Stack>
  )
}

export default Header
